import { render, staticRenderFns } from "./ShareToC.vue?vue&type=template&id=1a30e664&scoped=true&"
import script from "./ShareToC.vue?vue&type=script&lang=js&"
export * from "./ShareToC.vue?vue&type=script&lang=js&"
import style0 from "./ShareToC.vue?vue&type=style&index=0&id=1a30e664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a30e664",
  null
  
)

export default component.exports